

import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'
import { useState } from "react"

export const MonthlyWorkAnalysisExport = (props) => {
    const { ExcelData, name, WardName, FromDate, ToDate } = props

    const totalCount = ExcelData && ExcelData.table && ExcelData.table.reduce((total, item) => {
        return total + +(item.totalPenalty)
    }, 0)


    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-ExportMonthlyWorkAnalysisExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black', }}
            />


            <table id="table-to-ExportMonthlyWorkAnalysisExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>


                <h4 style={{ textAlign: 'center', fontSize: 16 }}>Navi Mumbai Municipal Corporation</h4>
                <h5 style={{ textAlign: 'center', fontSize: 16 }}>GARDEN DEPARTMENT</h5>
                <h5 style={{ textAlign: 'center', fontSize: 16 }}>Project Name: GARDEN MAINTENANCE - {WardName.Label ? WardName.Label : '-'}</h5>
                <h5 style={{ textAlign: 'center', fontSize: 16 }}> Garden Maintenance Preventive Works Total Amount:  Total Amount:- {totalCount && totalCount > 0 ? totalCount : '0'} Rs.</h5>
                <h5 style={{ textAlign: 'center', fontSize: 16 }}>Report Name: GARDEN PREVENTIVE WORK</h5>
                <h5 style={{ textAlign: 'center', fontSize: 16 }}>From Date:- {FromDate ? FromDate : '-'}  To Date:- {ToDate ? ToDate : '-'} </h5>

                <tr><td></td></tr>

                <thead className="thead-dark" >
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>

                        <th style={{ textAlign: 'center' }}>Sr.No.</th>
                        <th>Work Type</th>
                        <th>KPI Name</th>
                        <th>Work Assign Count</th>
                        <th>Work Completed in Time</th>
                        <th>Work Defaulter</th>
                        <th>Work Pending</th>
                        <th>Penalty Charged (Rs.)</th>
                        
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item, i) => (
                            <tr style={{ textAlign: "center" }}>
                                <td style={{ textAlign: "center"}}>1</td>
                                <td style={{ textAlign: "start" }}></td>
                                <td style={{ textAlign: "start" }}></td>
                                <td style={{ textAlign: "start" }}></td>
                                <td style={{ textAlign: "start" }}></td>
                                <td style={{ textAlign: "start" }}></td>
                                <td style={{ textAlign: "start" }}></td>
                                <td style={{ textAlign: "start" }}></td>
                            </tr>
                        )) : <tr>No data</tr>
                    }
                </tbody>
            </table>
        </div>
    )
}